import React, { useEffect, useState } from "react";
import AnalyticsIcon1 from "../../Assets/Logos/issues/AnalyticsIcon1.png";
import AnalyticsIcon2 from "../../Assets/Logos/issues/AnalyticsIcon2.png";
import AnalyticsIcon3 from "../../Assets/Logos/issues/AnalyticsIcon3.png";
import AnalyticsIcon4 from "../../Assets/Logos/issues/AnalyticsIcon4.png";

import Cards from "../../components/AdminSideComponents/Cards";
import { FaFilter, FaSearch, FaTimes } from "react-icons/fa";
import { MdAddCircle } from "react-icons/md";
import { BsReplyAll } from "react-icons/bs";
import { GrView } from "react-icons/gr";

import {
  AddIssueModal,
  ReplyHereModal,
} from "../../components/AdminSideComponents/IssueSectionModals/index";
import axios from "axios";
import EditStatusModal from "../../components/AdminSideComponents/IssueSectionModals/EditStatusModal";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import DeleteConfirmationModal from "../../components/AdminSideComponents/IssueSectionModals/DeleteConfirmationModal";
import { formatDate, truncateText } from "../../utils/dateFormat";
import EditIssueModal from "../../components/AdminSideComponents/IssueSectionModals/EditIssueModal";
import ViewIssueModal from "../../components/AdminSideComponents/IssueSectionModals/ViewIssueModal";

const Issues = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [filterOption, setFilterOption] = useState("Default");
  const [isReplyHereModal, setIsReplyHereModal] = useState(false);
  const [isAddIssueModalOpen, setIsAddIssueModalOpen] = useState(false);
  const [issueList, setIssueList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const [pagination, setPagination] = useState({});
  const [isEditStatusModalOpen, setIsEditStatusModalOpen] = useState(false);
  const [toEditIssue, setToEditIssue] = useState({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditStatusChanged, setIsEditStatusChanged] = useState(false); // a state for calling the getAllIssue after status change
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [analyticsIssues, setAnalyticsIssues] = useState({});

  const items = [
    {
      name: "Total Number of Issues",
      numberOfItems: analyticsIssues?.total || 0,
      icon: AnalyticsIcon1,
    },
    {
      name: "Unresolved Issues",
      numberOfItems: analyticsIssues?.inProgress || 0,
      icon: AnalyticsIcon2,
    },
    {
      name: "Resolved Issues",
      numberOfItems: analyticsIssues?.resolved || 0,
      icon: AnalyticsIcon3,
    },
    {
      name: "Invalidated Issues",
      numberOfItems: analyticsIssues?.invalidate || 0,
      icon: AnalyticsIcon4,
    },
  ];
  const getAllIssueList = async function () {
    setLoading(true);

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/issues/getallissues?page=${currentPage}&limit=${itemsPerPage}&search=${filterOption}&searchWord=${searchQuery}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("------> issues ", response.data);
        setIssueList(response.data.data);
        setLoading(false);
        setPagination(response.data.pagination);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllIssueList();
  }, [currentPage, filterOption, isEditStatusChanged]);

  useEffect(() => {
    getAllIssueList();
  }, [searchQuery]);

  const closeAddIssueModal = () => {
    setIsAddIssueModalOpen(false);
  };

  const closeReplyHereModal = () => {
    setIsReplyHereModal(false);
  };

  const togglefilterModal = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < pagination.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getAnalyticsIssues = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/issues/getanalysisissues`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("------> Analytics Expenses ", response.data);
        setAnalyticsIssues(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAnalyticsIssues();
  }, [isEditStatusChanged]);
  //getanalysisissues
  return (
    <div className="p-6 bg-primarybgColor ">
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Issues
      </h1>
      <Cards items={items} />

      <div className="p-4 bg-[#FFFFFF]  mt-6 rounded-lg ">
        <div className="flex justify-between relative items-center  flex-col gap-4  sm:flex-row">
          <div className="flex w-full md:text-left md:justify-start text-center  sm:justify-start ">
            <h1 className="text-[18px] mb-2 lg:mt-0 text-primaryTextColor sm:text-[24px] font-bold">
              Issues List
            </h1>
          </div>
          <div className="flex justify-between w-full md:w-fit  gap-4">
            <button
              onClick={togglefilterModal}
              className="  relative  md:w-[8rem]  flex items-center px-4 gap-2 py-2 bg-gray-200 shadow-xl rounded-md focus:outline-none"
            >
              <FaFilter size={20} className="text-primaryColor" />
              <span className="text-primaryTextColor">Filter</span>
              <svg
                className="w-4 h-4 ml-2 text-secondaryTextColor"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            {isDropdownOpen && (
              <div className="absolute sm:right-0 top-24 sm:top-10 w-48 z-50 p-4 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                <p className="font-semibold text-primaryTextColor mb-2">
                  SORT BY:
                </p>
                <div className="space-y-2">
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      value="Default"
                      checked={filterOption === "Default"}
                      onChange={() => {
                        setCurrentPage(1);
                        setIsDropdownOpen(false);
                        setFilterOption("Default");
                      }}
                      className="text-indigo-500 form-radio"
                    />
                    <span className="ml-2 text-primaryTextColor">Default</span>
                  </label>

                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      value="In Progress"
                      checked={filterOption === "In Progress"}
                      onChange={() => {
                        setCurrentPage(1);
                        setIsDropdownOpen(false);
                        setFilterOption("In Progress");
                      }}
                      className="text-indigo-500 form-radio"
                    />
                    <span className="ml-2 text-primaryTextColor">
                      In Progress
                    </span>
                  </label>

                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      value="Resolved"
                      checked={filterOption === "Resolved"}
                      onChange={() => {
                        setCurrentPage(1);
                        setIsDropdownOpen(false);
                        setFilterOption("Resolved");
                      }}
                      className="text-indigo-500 form-radio"
                    />
                    <span className="ml-2 text-primaryTextColor">Resolved</span>
                  </label>
                  <label className="flex items-center  cursor-pointer">
                    <input
                      type="radio"
                      value="Invalidate"
                      checked={filterOption === "Invalidate"}
                      onChange={() => {
                        setCurrentPage(1);
                        setIsDropdownOpen(false);
                        setFilterOption("Invalidate");
                      }}
                      className="text-indigo-500 form-radio"
                    />
                    <span className="ml-2 text-primaryTextColor">
                      Invalidate
                    </span>
                  </label>
                </div>
              </div>
            )}
            {/* <div className="relative w-full">
              <input
                type="text"
                placeholder="Search..."
                className="border w-[100%] lg:w-auto border-gray-300 rounded-lg p-2 pl-8 pr-10 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
                value={searchQuery}
                onChange={(e) => {
                  // setCurrentPage(1);
                  setSearchQuery(e.target.value);
                }}
              />
              <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-secondaryTextColor" />

              {searchQuery && (
                <FaTimes
                  onClick={() => setSearchQuery("")}
                  className="absolute top-3 right-3 text-secondaryTextColor cursor-pointer"
                />
              )}
            </div> */}

            <MdAddCircle
              onClick={() => setIsAddIssueModalOpen(true)}
              className="text-primaryColor flex-shrink-0 rounded-lg cursor-pointer"
              size={40}
            />
          </div>

          {/* Dropdown for Filter */}
        </div>
      </div>

      <div className="mt-6 min-h-[70vh] flex flex-col justify-between">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {loading ? (
            Array.from({ length: 6 }).map((_, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-lg shadow-md p-4 animate-pulse"
              >
                {/* Header Shimmer */}
                <div className="flex justify-between mb-2">
                  <div className="h-6 bg-gray-300 rounded w-1/3"></div>
                  <div className="h-6 bg-gray-300 rounded w-1/4"></div>
                </div>

                {/* Description Shimmer */}
                <div className="h-4 bg-gray-300 rounded mb-4 w-5/6"></div>
                <div className="h-4 bg-gray-300 rounded mb-4 w-3/4"></div>

                {/* Footer Shimmer */}
                <div className="flex justify-between items-center">
                  <div className="flex flex-row gap-4">
                    <div className="flex flex-col">
                      <div className="h-4 bg-gray-300 rounded w-12"></div>
                      <div className="h-4 bg-gray-300 rounded w-16 mt-1"></div>
                    </div>
                    <div className="flex flex-col">
                      <div className="h-4 bg-gray-300 rounded w-12"></div>
                      <div className="h-4 bg-gray-300 rounded w-16 mt-1"></div>
                    </div>
                  </div>
                  <div className="h-10 bg-gray-300 rounded w-24"></div>
                </div>
              </div>
            ))
          ) : issueList.length > 0 ? (
            issueList.map((issue, index) => (
              <div
                key={issue.id}
                className="bg-white border relative border-gray-200 rounded-lg shadow-md p-4 hover:shadow-lg transition-shadow"
              >
                <div className="flex justify-between mb-2">
                  <h2 className="text-gray-700   text-md md:text-lg font-semibold mb-2">
                    {itemsPerPage * (currentPage - 1) + index + 1}{" "}
                    {". " + issue.issueTitle}
                    <p className="text-xs md:text-sm md:tracking-normal  text-nowrap">
                      {issue?.buildingName?.nameBuilding}
                    </p>
                    <p className="text-[#60727E] flex gap-2">
                      <span className="text-xs md:text-sm">Date : </span>{" "}
                      <span className="font-semibold text-xs md:text-sm text-[#263238]">
                        {formatDate(issue.createdAt)}
                      </span>
                    </p>
                  </h2>
                  <button
                    title="Update Status"
                    onClick={() => {
                      setToEditIssue(issue);
                      setIsEditStatusModalOpen(true);
                    }}
                    className={`px-4 h-fit py-2 text-xs  md:text-sm rounded-md font-medium ${
                      issue.issueStatus === "In Progress"
                        ? "bg-yellow-100 text-yellow-600 "
                        : issue.issueStatus === "Resolved"
                        ? "bg-green-100 text-green-600"
                        : "bg-red-100 text-red-600"
                    }`}
                  >
                    {issue.issueStatus}
                  </button>
                </div>
                <p className="text-[#202224]   text-xs md:text-[15px] tracking-normal leading-normal mb-4 md:mb-14 font-semibold">
                  {truncateText(issue.issueDescription, 20)}
                </p>
                <div className="">
                  <div className="flex  flex-col md:flex-row justify-between gap-4 md:gap-0  items-center">
                    <div className="flex w-full md:w-fit justify-between  md:absolute bottom-4 left-4 flex-row gap-4 text-xs md:text-sm">
                      <p className="text-[#60727E] flex flex-col">
                        <span className="text-xs"> By Whom</span>{" "}
                        <span className="font-semibold text-[#263238]">
                          {issue.user || "Admin"}
                        </span>
                      </p>
                      <p className="text-[#60727E] flex flex-col">
                        <span className="text-xs">Category</span>{" "}
                        <span className="font-semibold text-[#263238]">
                          {issue?.issueType}
                        </span>
                      </p>
                      <p className="text-[#60727E] flex flex-col">
                        <span className="text-xs">Last Updated</span>{" "}
                        <span className="font-semibold text-[#263238]">
                          {formatDate(issue?.updatedAt || "N/A")}
                        </span>
                      </p>
                    </div>
                    <div className="flex justify-between w-full md:w-fit  md:absolute  bottom-4 right-4  gap-2 items-center">
                      <button
                        onClick={() => {
                          setToEditIssue(issue);
                          setIsReplyHereModal(true);
                        }}
                        className=" w-fit px-4 border border-gray-300 text-[#344054] text-sm py-2 rounded-lg hover:border-gray-600 transition-colors"
                      >
                        {/* Reply Here */}
                        <BsReplyAll />
                      </button>
                      <button
                        onClick={() => {
                          setToEditIssue(issue);
                          setIsViewModalOpen(true);
                        }}
                        className=" w-fit px-4 border border-green-300 text-green-700 text-sm py-2 rounded-lg hover:border-green-600 transition-colors"
                      >
                        {/* View */}
                        <GrView />
                      </button>
                      <button
                        onClick={() => {
                          setIsEditModalOpen(true);
                          setToEditIssue(issue);
                        }}
                        className="flex items-center gap-1 px-4 py-2 border border-gray-300 text-blue-600 text-sm rounded-lg hover:border-blue-400 transition-colors"
                      >
                        <AiOutlineEdit className="text-lg" />
                      </button>
                      <button
                        onClick={() => {
                          setToEditIssue(issue);
                          setIsDeleteModalOpen(true);
                        }}
                        className="flex items-center gap-1 px-4 py-2 border border-gray-300 text-red-600 text-sm rounded-lg hover:border-red-400 transition-colors"
                      >
                        <AiOutlineDelete className="text-lg" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="w-full bg-white rounded-md col-span-2 h-[70vh] flex justify-center items-center text-xl">
              <p>No Issues Found</p>
            </div>
          )}
        </div>
        <div className="flex justify-between items-center mt-4">
          <p className="text-sm text-secondaryTextColor">
            Showing {itemsPerPage * (currentPage - 1) + 1}-
            {Math.min(itemsPerPage * currentPage, pagination.totalIssues)} of{" "}
            {pagination.totalIssues}
          </p>
          <div className="flex space-x-2">
            <button
              className={`${
                currentPage === 1 ? "bg-gray-300" : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              ←
            </button>
            <button
              className={`${
                currentPage === pagination.totalPages
                  ? "bg-gray-300"
                  : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToNextPage}
              disabled={currentPage === pagination.totalPages}
            >
              →
            </button>
          </div>
        </div>

        <DeleteConfirmationModal
          editStatusChanged={() => setIsEditStatusChanged((prev) => !prev)} //
          isOpen={isDeleteModalOpen}
          issue={toEditIssue}
          onClose={() => setIsDeleteModalOpen(false)}
        />

        <EditIssueModal
          editStatusChanged={() => setIsEditStatusChanged((prev) => !prev)}
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          currentIssue={toEditIssue}
        />

        <ViewIssueModal
          issue={toEditIssue}
          isOpen={isViewModalOpen}
          onClose={() => setIsViewModalOpen(false)}
        />

        <EditStatusModal
          editStatusChanged={() => setIsEditStatusChanged((prev) => !prev)}
          issue={toEditIssue}
          isOpen={isEditStatusModalOpen}
          onClose={() => setIsEditStatusModalOpen(false)}
        />

        <ReplyHereModal
          issue={toEditIssue}
          isOpen={isReplyHereModal}
          closeModal={closeReplyHereModal}
        />
        <AddIssueModal
          editStatusChanged={() => setIsEditStatusChanged((prev) => !prev)} //
          isOpen={isAddIssueModalOpen}
          onClose={closeAddIssueModal}
        />
      </div>
    </div>
  );
};

export default Issues;
